import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';


declare const $: any;

@Component({
    selector: 'app-question-label-percentage',
    templateUrl: './question-label-percentage.component.html',
    styleUrls: ['./question-label-percentage.component.scss'],
    standalone: false
})
export class QuestionLabelPercentageComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() question: Question;
  @Input() showToolTip = false;
  @Input() showDelete = false;
  @Output() questionAnswer = new EventEmitter<any>();

  value = '';
  uniqueControlName = `label-percentage-${newGuid()}`;
  uniqueId = `label-percentage-${newGuid()}`;

  constructor(private questionService: GlobalQuestionService) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.questionService.initPopoverCustomize();
    }, 500);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.value = '';
    if (changes?.question?.currentValue) {
      this.question = changes?.question?.currentValue;
      if (this.question?.answer) {
        this.value = this.question?.answer;
      }
    }
    if (changes?.showToolTip?.currentValue) {
      this.showToolTip = changes?.showToolTip?.currentValue;
    }
    if (changes?.showDelete?.currentValue) {
      this.showDelete = changes?.showDelete?.currentValue;
    }
  }

  onChange(): void {
    if (this.value) {
      let num = parseFloat(this.value);
      if (isNaN(num)) {
        num = 0;
      }
      num = Math.min(100, Math.max(0, num));
      this.value = num.toString();
    }
    if (this.question) {
      this.question.answer = this.value;
      this.questionAnswer.emit(this.question);
    } else {
      this.questionAnswer.emit(this.value);
    }
  }

}
